import { render, staticRenderFns } from "./header-selection.vue?vue&type=template&id=a34cc7e2&scoped=true&"
import script from "./header-selection.vue?vue&type=script&lang=js&"
export * from "./header-selection.vue?vue&type=script&lang=js&"
import style0 from "./header-selection.vue?vue&type=style&index=0&id=a34cc7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34cc7e2",
  null
  
)

export default component.exports